import eventBus from "../services/event-bus";
import { elementExists } from "../utils";
import FadeOut from "../utils/fadeOut";
import QuantityComponent from "./quantity";

/**
 * Cart
 * Cart Display
 * Initializes line item remove + quantity updates
 * Listes for removed and quantity updates
 **/
const Cart  = function( element ){
	Shopify.theme = Shopify.theme || {};
  	const CartService = Shopify.cartService

		let $this = {};
    $this.container = element;
		$this.classes = {
			cartEmpty : 'empty' 
		}
		$this.selectors = {
			cartItem: '[data-cart-item]',
			cartRemove : '[data-cart-remove]',
			cartCount : '[data-cart-count]',
			cartSubTotal : '[data-cart-subtotal]',
			cartAjaxContainer : '[data-cart-line-items-ajax-container]'
		}
		$this.attributes = {
			sideBarCart: 'data-sidebar-cart',
			cartItemIndex: 'data-cart-item-index',
			cartItemKey: 'data-cart-item-key',
			cartItemQuantity: 'data-cart-item-quantity',
			cartItemTitle: 'data-cart-item-title',
			cartItemUrl: 'data-cart-item-url',
			quantityItem: 'data-quantity-item'
		};
		$this.init = function(){
			$this.initElements();
			eventBus.on( eventBus.types.CartUpdated  , $this.onCartUpdated );
			eventBus.on( eventBus.types.QuantityUpdated , $this.onQuantityUpdated )
			eventBus.on( eventBus.types.AddedToCart , $this.updateAjaxCart )
			eventBus.on( eventBus.types.CartOpened , $this.updateAjaxCart )
		}


		$this.initElements = function( $updateQuantityButtons = false ){
			$this.cartCount = $this.container.querySelector( $this.selectors.cartCount );
			$this.cartSubTotal = $this.container.querySelector(  $this.selectors.cartSubTotal );
			$this.cartAjaxContainer = $this.container.querySelector( $this.selectors.cartAjaxContainer ); 
			const removeButtons = $this.container.querySelectorAll( $this.selectors.cartRemove);
			if( elementExists( removeButtons)){
				removeButtons.forEach( function( $el){
				  $el.addEventListener( 'click', $this.removeItem )
				});
			}
			if( $updateQuantityButtons ){
				const QuantityComponents = $this.container.querySelectorAll( '[sh-quantity-component]' )
				if( elementExists( QuantityComponents , true )){
				  QuantityComponents.forEach( function( $el ){
					( new QuantityComponent( $el ) );
				  });
				}
  
			}
		}
		
	
		$this.removeItem = function( e ){
			e.preventDefault();
			const target = e.currentTarget;
			const lineItem = target.closest($this.selectors.cartItem);
			const key = lineItem.getAttribute($this.attributes.cartItemKey);
			// this._hideCartError();
			CartService.removeItem( key ).then( function( response ){
				if( response.success )  FadeOut( lineItem ) ;
			});
		}
		$this.updateCart = function(){

		}

		$this.updateAjaxCart = function(){
			fetch('/cart?view=ajax')
			.then(function(response) {
			  return response.text();
			})
			.then(function(body) {
			  $this.cartAjaxContainer.innerHTML = body;
			  eventBus.dispatch( eventBus.types.AjaxCartRefreshed )
			  $this.initElements( true );
			});			
		}

		$this.onQuantityUpdated = function( e ) {
			var target = e.detail.target;
			var lineItem = target.closest($this.selectors.cartItem);
			if( elementExists( lineItem)){
				var key = lineItem.getAttribute($this.attributes.cartItemKey);
				CartService.updateQuantity( key, e.detail.value ).then( function( res ){
					if( res.success && e.detail.value == 0 ){
						if( lineItem.hasAttribute( 'data-cart-item-index' )){
							FadeOut( lineItem);
						}
					}
				});
			}
		};
		  		
		$this.onCartUpdated = function(){
			// the cart is empty just hide it. 
			if( CartService.cart.item_count == 0 ) {
				$this.container.classList.add( $this.classes.cartEmpty );
				return;
			}else{
				$this.container.classList.remove( $this.classes.cartEmpty );
			}
			// update the cart count
			if( CartService.cart.item_count == 1 ){
				$this.cartCount.innerText =  CartService.cart.item_count  + ' Item';
			}else { 
				$this.cartCount.innerText =  CartService.cart.item_count + ' Items' ;
			}
			// update the subtotal 
			$this.cartSubTotal.innerText  =  Shopify.formatMoney( CartService.cart.total_price)  ;
			
		}



    $this.init();
    return $this;
}

export default Cart;
